// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.70bab6479.chunk.js";
	if (chunkId === 12) return "static/js/profiler.70bab6479.chunk.js";
	if (chunkId === 658) return "static/js/658.70bab6479.chunk.js";
	if (chunkId === 621) return "static/js/621.70bab6479.chunk.js";
	if (chunkId === 590) return "static/js/590.70bab6479.chunk.js";
	if (chunkId === 676) return "static/js/676.70bab6479.chunk.js";
	if (chunkId === 978) return "static/js/978.70bab6479.chunk.js";
	if (chunkId === 103) return "static/js/103.70bab6479.chunk.js";
	if (chunkId === 177) return "static/js/177.70bab6479.chunk.js";
	if (chunkId === 292) return "static/js/292.70bab6479.chunk.js";
	if (chunkId === 570) return "static/js/570.70bab6479.chunk.js";
	if (chunkId === 547) return "static/js/547.70bab6479.chunk.js";
	// return url for filenames based on template
	return undefined;
};